import { RightArrowIcon } from '@/components/common/icon';
import React, { useState, useEffect } from 'react';
import { items } from './config';

interface Props {
  step: number;
  maxStep: number;
  setStep: Function;
}

const MobileSteps: React.FC<Props> = ({ step, maxStep, setStep }) => {
  return (
    <div
      className={`flex justify-start items-center gap-1.5 mb-6 mt-4 overflow-hidden w-full`}
    >
      {items?.map((item: string, index: number) => (
        <>
          <div
            className={`pl-1 pr-1.5 py-1.5 rounded flex justify-center items-center gap-2.5 flex-shrink-0 whitespace-nowrap relative ${index === step ? 'bg-[#f1f3f4]' : ''} ${step >= 2 ? 'left-[-200px]' : ''}`}
            onClick={() => {
              if (maxStep >= index) {
                setStep(index);
              }
            }}
          >
            <div className="justify-start text-[#60646c] text-xs font-medium font-['Inter']">
              {index + 1}. {item}
            </div>
          </div>
          {index !== items.length - 1 && (
            <RightArrowIcon
              className={`flex-shrink-0 relative ${step >= 2 ? 'left-[-200px]' : ''}`}
            />
          )}
        </>
      ))}
    </div>
  );
};

export default MobileSteps;
